export default "__VITE_ASSET__64e612ca__"